module.exports = __webpack_public_path__ + "37ced6119a8af87b59a464529835fa85.svg";